import { render, staticRenderFns } from "./AttachmentIcon.vue?vue&type=template&id=74bc9ac2"
import script from "./AttachmentIcon.vue?vue&type=script&lang=js"
export * from "./AttachmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports